import cn from "../../utils/cn"

const badge = "px-2 py-0.5 text-[10px] rounded-full border whitespace-nowrap"

/*
  One record in the master list: status and accession on the first line, then
  whatever this record has to show for itself on the second.

  Every row carries `border-l-2 border-l-transparent` whether selected or not —
  adding the accent border only when selected would shift the text 2px on click.
*/
const LogsSidebarRow = ({ log, videos, isSelected, onSelect }) => {
  const scans = log.scanSummary

  return (
    <li
      aria-selected={isSelected}
      className={cn(
        "px-3.5 py-3 border-b border-gray-200 border-l-2 border-l-transparent cursor-pointer",
        isSelected ? "bg-blue-50 border-l-secondary" : "hover:bg-gray-50"
      )}
      id={`log-option-${log.ReportVideosLogId}`}
      role="option"
      onClick={onSelect}
    >
      <div className="flex items-center gap-2 mb-1.5">
        <span
          className={cn(
            "w-2 h-2 rounded-full shrink-0",
            log.IsError ? "bg-red-500" : "bg-green-500"
          )}
        />
        {/* The dot is colour-only, so the state is spelled out for screen readers. */}
        <span className="sr-only">{log.IsError ? "Errored" : "Succeeded"}</span>
        <span className="text-sm font-semibold text-gray-900 truncate">
          {log.AccessionNo}
        </span>
      </div>

      <div className="flex flex-wrap gap-1">
        {videos.length > 0 ? (
          <span
            className={cn(badge, "bg-blue-50 border-blue-200 text-blue-700")}
          >
            {videos.length} video{videos.length !== 1 ? "s" : ""}
          </span>
        ) : (
          <span
            className={cn(badge, "bg-gray-50 border-gray-200 text-gray-500")}
          >
            0 videos
          </span>
        )}

        {scans?.TotalScans > 0 && (
          <span
            className={cn(badge, "bg-green-50 border-green-200 text-green-700")}
            title={`${scans.TotalScans} total scan(s), ${scans.UniqueScans} unique`}
          >
            {scans.TotalScans} scan{scans.TotalScans !== 1 ? "s" : ""}
          </span>
        )}

        {scans?.FeedbackSubmittedAt && (
          <span
            className={cn(
              badge,
              "bg-purple-50 border-purple-200 text-purple-700"
            )}
            title="A feedback response was submitted for this report"
          >
            feedback
          </span>
        )}
      </div>
    </li>
  )
}

export default LogsSidebarRow
